import $ from "../$.js";
import * as Html from "../util/Html.ts";
export {init,destroy}
Html.registerWidget('widget/endintoview',{init:init,destroy:destroy})
function crawlForScrollable(el){
  
  return el.parents().filter(function(idx,obj){
    return ['scroll','auto','overlay'].indexOf($(obj).css('overflow-y'))>-1;
  }).first();
}
function visible_in_container(p, e) {
  try{
    var 
      z = p.getBoundingClientRect(),
      r = e.getBoundingClientRect();
    // Check style visiblilty and off-limits
    return  !(r.top > z.bottom || r.bottom < z.top );
  }catch(err){
    return false;
  }
}

function handle(scrollable,element){
  if(element.is(":visible") && visible_in_container(element.get(0),scrollable.get(0))){
    clearInterval(Number(element.attr('interval')));
    element.trigger('endintoview',element);
  }
  
}

function init(element){
  var
    scrollable = crawlForScrollable(element);
  //tryied with .data but it didn't work...
  element.attr('interval',setInterval(function(){handle(scrollable,element);},350));
}

function destroy(element){
  clearInterval(Number(element.attr('interval')));
}